<template>
  <b-container fluid>
    <b-overlay :show="loading">
      <b-row>
        <b-col lg="12" sm="12">
          <iq-card>
            <template v-slot:body>
              <b-row>
                <b-col lg="11" sm="12">
                  <ValidationObserver ref="form"  v-slot="{ handleSubmit }">
                  <b-form  @submit.prevent="handleSubmit(register)" >
                    <ValidationProvider name="Amount" vid='total_cost' rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="12"
                        :label="$t('externalUser.payment')"
                        label-for="total_cost"
                        slot-scope="{ valid, errors }"
                      >
                        <b-form-input
                          id="total_cost"
                          v-model="payment.total_cost"
                          :state="errors[0] ? false : (valid ? true : null)"
                          ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                    <b-row>
                        <b-col>
                          <b-button class="btn-block" type="submit" variant="primary">{{ $t('externalUser.pay') }}</b-button>
                        </b-col>
                    </b-row>
                  </b-form>
                </ValidationObserver>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { pendingapplyStallStore } from '../../api/routes'

export default {
  props: ['singleData'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      loadingState: true,
      saveBtnName: this.$t('globalTrans.save'),
      payment: {
        id: this.singleData.id,
        total_cost: this.singleData.total_cost,
        is_bypass: 0
      }
    }
  },
  methods: {
    async register () {
    this.loading = true
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: true }
      result = await RestApi.postData(awarenessEventServiceBaseUrl, pendingapplyStallStore, this.payment)
      this.$store.dispatch('mutateCommonProperties', loadinState)
      if (result.success) {
        if (result.success === 2) {
          this.$toast.success({
            title: 'Success',
            message: result.message
          })
        } else {
          window.location = result.url
        }
        this.$bvModal.hide('modal-payment')
      } else {
        this.$refs.form.setErrors(result.errors)
        this.$toast.error({
          title: 'Error',
          message: result.message
        })
      }
    }
  }
}
</script>
